<template>
  <div class="select-establishment">
    <div class="row" style="margin-top: 10vh">
        <div class="col-10 ms-auto me-auto col-sm-4" style="background: white; padding: 20px; border-radius: 15px">
            <div>
              <logo style="margin-bottom: 18px"/>
            </div>
            <p style="text-align: center">
              Selecteer een vestiging
            </p>
            <hr>
            <div v-if="establishments && establishments.length > 10">
              <input
                  type="text"
                  placeholder="Zoek op naam"
                  v-model="query"
                  class="form-control"
                  style="margin-bottom: 15px"
              >
            </div>
            <div v-if="filteredEstablishments && filteredEstablishments.length > 0">
                <div class="d-grid gap-2">
                    <button
                        v-for="establishment in sortArrayByProperty(filteredEstablishments, 'name')"
                        :key="establishment.id"
                        v-on:click="selectEstablishment(establishment)"
                        class="btn btn-info"
                    >
                        {{ establishment.name }}
                    </button>
                    <hr>
                    <router-link to="/logout" class="btn btn-danger">
                        Uitloggen
                    </router-link>
                </div>
            </div>
            <div v-else-if="establishments && establishments.length > 0">
              <p class="text-center p-padding">
                Geen resultaten...
              </p>
            </div>
            <div v-else>
              <p class="text-center p-padding">
                Geen vestigingen gevonden...
              </p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo'
export default {
  name: 'select-establishment',
  components: {
    Logo
  },
  data () {
    return {
      query: ''
    }
  },
  created () {
    this.$store.commit('SET_SHOW_SIDE_NAVBAR', false)
    this.$store.dispatch('getEstablishments')
  },
  computed: {
    establishments () {
      return this.$store.getters.establishments
    },
    filteredEstablishments () {
      if (this.query !== '') {
        var establishments = this.$store.getters.establishments
        var self = this
        var query = this.query.toLowerCase()
        return this.$lodash().filter(establishments, function (establishment) {
          return self.$lodash().includes(establishment.name.toLowerCase(), query)
        })
      } else {
        return this.$store.getters.establishments
      }
    }
  },
  methods: {
    selectEstablishment (establishment) {
      this.$store.dispatch('switchEstablishment', establishment.id)
      this.$store.commit('SET_SELECTED_ESTABLISHMENT', establishment)
      this.$store.dispatch('loadApplicationSettings')
      this.$router.push('/select-group')
    }
  }
}
</script>

<style scoped>
.p-padding {
  padding-top: 15px;
}
</style>
